/* unplugin-vue-components disabled */import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import { useEmptyStringFormat } from '@/hooks/fn';
import CTypeTab from '@/components/CTypeTab.vue';
import DateHeaderWithBtn from '@/views/Feeding/cpns/DateHeaderWithBtn.vue';
// import localCache from '@/utils/localCache';
import useSaleData from './hooks/useSaleData';
import ListDataItem from './cpns/ListDataItem.vue';
import CNoData from '@/components/CNoData.vue';
import { getTimeRange } from '@/views/Feeding/hooks/time';
export default defineComponent({
  name: 'BeltScaleData',
  components: {
    CTypeTab: CTypeTab,
    ListDataItem: ListDataItem,
    DateHeaderWithBtn: DateHeaderWithBtn,
    CNoData: CNoData
  },
  setup: function setup() {
    var params = ref({
      type: 0,
      startTime: "".concat(dayjs().format('YYYY-MM-DD'), " 00:00:00"),
      endTime: "".concat(dayjs().format('YYYY-MM-DD'), " 23:59:59"),
      pageNumber: 10,
      pageSize: 1,
      condition: ''
    });
    var confirmDate = function confirmDate(val) {
      var timeData = getTimeRange(params.value.type, val);
      params.value.startTime = timeData.startTime;
      params.value.endTime = timeData.endTime;
      params.value.pageSize = 1;
      saleData.value = [];
      finished.value = false;
      loading.value = false;
      getSaleDataAsync();
    };
    var dateRef = ref();
    var confirmType = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        var _dateRef$value;
        var date, timeData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params.value.type = val;
              //把所以日期控件的日期变为当前最新日期
              (_dateRef$value = dateRef.value) === null || _dateRef$value === void 0 || _dateRef$value.reset();
              date = '';
              if (val === 3) {
                date = "".concat(dayjs().format('YYYY/MM/DD'), " 00:00:00,").concat(dayjs().format('YYYY/MM/DD HH:mm:ss'));
              } else {
                date = dayjs().format('YYYY/MM/DD');
              }
              timeData = getTimeRange(params.value.type, date);
              params.value.startTime = timeData.startTime;
              params.value.endTime = timeData.endTime;
              params.value.pageSize = 1;
              saleData.value = [];
              finished.value = false;
              loading.value = false;
              getSaleDataAsync();
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function confirmType(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var onSearch = function onSearch() {
      //页码重置为1 list清空
      params.value.pageSize = 1;
      saleData.value = [];
      finished.value = false;
      loading.value = false;
      getSaleDataAsync();
    };
    var _useSaleData = useSaleData(params),
      _useSaleData2 = _slicedToArray(_useSaleData, 10),
      saleData = _useSaleData2[0],
      totalRow = _useSaleData2[1],
      totalWeight = _useSaleData2[2],
      totalPay = _useSaleData2[3],
      loading = _useSaleData2[4],
      finished = _useSaleData2[5],
      refreshing = _useSaleData2[6],
      onRefresh = _useSaleData2[7],
      getSaleDataAsync = _useSaleData2[8],
      onLoad = _useSaleData2[9];
    var emptyStringFormat = useEmptyStringFormat();
    var summaryData = computed(function () {
      return saleData.value;
    });
    onMounted(function () {
      getSaleDataAsync();
    });
    // const router = useRouter();
    return {
      params: params,
      confirmType: confirmType,
      confirmDate: confirmDate,
      emptyStringFormat: emptyStringFormat,
      summaryData: summaryData,
      loading: loading,
      finished: finished,
      refreshing: refreshing,
      onRefresh: onRefresh,
      onLoad: onLoad,
      dateRef: dateRef,
      onSearch: onSearch,
      totalRow: totalRow,
      totalWeight: totalWeight,
      totalPay: totalPay
    };
  }
});